<template>
  <div v-if="richTextContent" v-dompurify-html="richTextContent"></div>
</template>

<script lang="ts" setup>
import markdownit from "markdown-it";
const md = markdownit();

const props = defineProps({
  content: {
    type: [String, Object],
    required: true,
    default: "",
  },
  raw: {
    type: Boolean,
    default: true,
  },
});

const richTextContent = computed(() => {
  if (!props.content) return "";

  if (typeof props.content === "object" && props.content.text) {
    return md.render(props.content.text);
  }

  if (typeof props.content === "string") {
    return md.render(props.content);
  }

  return "";
});
</script>
